var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Banner, Box, Button, IconButton } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import classnames from 'classnames';
import MomentTimezone from 'moment-timezone';
import * as React from 'react';
import { actions as conversationActions } from 'components/conversation/actions/conversation';
import { withRouter } from 'hocs/router';
import { NotificationLayout } from './notificationLayout';
import styles from './notificationToaster.module.scss';
export const { conversationExtendAcw } = conversationActions;
function timerFormat(timeLeftInMilisec) {
    let time = timeLeftInMilisec / 1000;
    let day = '';
    const days = Math.floor(time / 86400); // Days in int.
    if (days > 0) {
        day = days === 1 ? `${days} day ` : `${days} days `;
    }
    let format = 's';
    const hours = Math.floor(time / 3600);
    time = time - hours * 3600;
    const hoursFormat = hours > 0 ? `${hours}:` : '';
    const minutes = Math.floor(time / 60);
    const minutesFormat = minutes > 0 ? `${minutes}:` : '';
    if (minutesFormat) {
        format = 'mm:ss';
    }
    if (hoursFormat) {
        format = 'HH:mm:ss';
    }
    const timeLeft = MomentTimezone(timeLeftInMilisec).utc().format(format);
    return `${day}${timeLeft}`;
}
class NotificationToasterImpl extends React.PureComponent {
    hasTimer(notification) {
        return notification.startTime !== null && notification.startTime > 0;
    }
    hasLeftAction(notification) {
        return !!notification.leftAction && !notification.leftAction.hidden;
    }
    hasRightAction(notification) {
        return !!notification.rightAction && !notification.rightAction.hidden;
    }
    hasAction(notification) {
        return (this.hasLeftAction(notification) || this.hasRightAction(notification));
    }
    getNewStateFromStartTime(startTime) {
        return {
            timeLeft: startTime ? startTime : null,
            progress: startTime && startTime > 0 ? 100 : null,
        };
    }
    constructor(props) {
        super(props);
        const { notification: { startTime }, } = props;
        if (startTime) {
            this.intervalId = global.setInterval(this.setProgress, 100);
        }
        this.state = this.getNewStateFromStartTime(startTime);
    }
    componentWillUnmount() {
        // Remove timer setInterval.
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }
    componentDidUpdate(prevProps) {
        const { notification: { shouldBeRemovedAt: prevShouldBeRemovedAt }, } = prevProps;
        const { notification: { startTime, shouldBeRemovedAt }, } = this.props;
        if (prevShouldBeRemovedAt !== shouldBeRemovedAt) {
            // We need to clear the timer setInterval.
            if (this.intervalId) {
                clearInterval(this.intervalId);
            }
            // We update the state with the new timeLeft and progress.
            this.setState(this.getNewStateFromStartTime(startTime), () => {
                if (startTime) {
                    // When new state is set we start a new timer.
                    this.intervalId = global.setInterval(this.setProgress, 100);
                }
            });
        }
    }
    setProgress() {
        const { notification } = this.props;
        if (this.hasTimer(notification)) {
            const nowUnixTime = new Date().getTime();
            const { startTime: timerRunTime, shouldBeRemovedAt: endTime } = notification;
            const startTime = endTime - timerRunTime;
            const progressCountDown = 100 - (100 / (endTime - startTime)) * (nowUnixTime - startTime);
            const progressNormalized = Math.min(100, Math.max(progressCountDown, 0));
            const timeLeft = Math.round(endTime - nowUnixTime);
            if (progressNormalized === 0) {
                this.timerFinished();
            }
            else {
                this.setState({ timeLeft, progress: progressNormalized });
            }
        }
    }
    timerFinished() {
        const { notification, dispatch } = this.props;
        // Remove notification from reducer and remove the setInterval from here
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
        this.setState({ timeLeft: 0, progress: 0 });
        if (typeof notification.actionOnTimeout === 'function') {
            notification.actionOnTimeout(dispatch);
        }
        this.props.notificationRemoveById({ id: notification.id });
    }
    getProgress(notification) {
        if (this.hasTimer(notification)) {
            return { width: this.state.progress + '%' };
        }
        return {};
    }
    handleActionButton(notification, side) {
        const buttonSide = notification[side];
        if (buttonSide === null || buttonSide === void 0 ? void 0 : buttonSide.action) {
            const action = buttonSide.action;
            if (typeof action === 'function') {
                this.nextAndExecute(action());
            }
            else if (typeof (action === null || action === void 0 ? void 0 : action.navigate) === 'string') {
                this.props.navigate(action.navigate);
            }
        }
        return;
    }
    handleActionButtonLeft() {
        const { notification } = this.props;
        this.handleActionButton(notification, 'leftAction');
    }
    handleActionButtonRight() {
        const { notification } = this.props;
        this.handleActionButton(notification, 'rightAction');
    }
    nextAndExecute(action) {
        var _a, _b;
        // abort if we have not passed an iterator
        if (!action || !(typeof (action === null || action === void 0 ? void 0 : action.next) === 'function'))
            return;
        const next = action.next();
        if (next.value) {
            const nextCopy = Object.assign({}, next);
            const { timeLeft } = this.state;
            // We add remaining duration to the extended time.
            if (((_a = nextCopy.value) === null || _a === void 0 ? void 0 : _a.payload.action.type) === conversationExtendAcw.toString()) {
                nextCopy.value.payload.action.payload.duration = Math.round(next.value.payload.action.payload.duration +
                    timeLeft / 1000);
            }
            if ((_b = nextCopy.value) === null || _b === void 0 ? void 0 : _b.payload.action) {
                this.props.dispatch(nextCopy.value.payload.action);
            }
            this.nextAndExecute(action);
        }
    }
    handleClose() {
        const { notification } = this.props;
        if (typeof (notification === null || notification === void 0 ? void 0 : notification.closeAction) === 'function') {
            this.nextAndExecute(notification.closeAction());
        }
        else if (notification === null || notification === void 0 ? void 0 : notification.id) {
            this.props.notificationRemoveById({ id: notification.id });
        }
    }
    getRightButtonText() {
        var _a, _b;
        const { notification } = this.props;
        const base = (_b = (_a = notification.rightAction) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : '';
        const timeLeft = typeof this.state.timeLeft === 'number'
            ? timerFormat(this.state.timeLeft)
            : '';
        return `${base} ${timeLeft}`;
    }
    render() {
        var _a, _b;
        const { notification, className } = this.props;
        const { status } = notification;
        const rootClass = classnames({
            [styles.root]: styles.root,
            [styles.rootSuccess]: status === 'success',
            [styles.rootWarning]: status === 'warning',
            [styles.rootDanger]: status === 'danger',
        }, className);
        return (_jsxs(Box, Object.assign({ className: rootClass }, { children: [!notification.hideCloseAction && (_jsx(IconButton, { icon: "close", variant: "tertiary", className: styles.close, onClick: this.handleClose })), _jsx(NotificationLayout, { notification: notification }), notification.banner && (_jsx(Box, Object.assign({ margin: "300 0 0 0" }, { children: _jsx(Banner, Object.assign({}, notification.banner)) }))), this.hasTimer(notification) && (_jsx(Box, Object.assign({ className: styles.progress }, { children: _jsx(Box, { className: styles.progressBar, style: this.getProgress(notification) }) }))), this.hasAction(notification) && (_jsxs(Box, Object.assign({ className: styles.actions }, { children: [this.hasLeftAction(notification) && (_jsx(Button, Object.assign({ variant: "secondary", onClick: this.handleActionButtonLeft, className: styles.action, disabled: (_a = notification.leftAction) === null || _a === void 0 ? void 0 : _a.disabled }, { children: notification.leftAction ? notification.leftAction.text : '' }))), this.hasRightAction(notification) && (_jsx(Button, Object.assign({ variant: "secondary", onClick: this.handleActionButtonRight, className: styles.action, disabled: (_b = notification.rightAction) === null || _b === void 0 ? void 0 : _b.disabled }, { children: this.getRightButtonText() })))] })))] })));
    }
}
__decorate([
    boundMethod
], NotificationToasterImpl.prototype, "setProgress", null);
__decorate([
    boundMethod
], NotificationToasterImpl.prototype, "timerFinished", null);
__decorate([
    boundMethod
], NotificationToasterImpl.prototype, "handleActionButtonLeft", null);
__decorate([
    boundMethod
], NotificationToasterImpl.prototype, "handleActionButtonRight", null);
__decorate([
    boundMethod
], NotificationToasterImpl.prototype, "nextAndExecute", null);
__decorate([
    boundMethod
], NotificationToasterImpl.prototype, "handleClose", null);
export const NotificationToaster = withRouter(NotificationToasterImpl);
